/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {makeStyles} from '@material-ui/core/styles';
import {Box} from "@material-ui/core";
import {colors} from '../shared/colors'

const useStyles = makeStyles({
    option: {
        fontSize: 15,
    },
    colorBox: {
        boxSizing: "border-box",
        width: "48px",
        height: "28px",
        overflow: "visible",
        borderRadius: "2px",
        border: "1px solid #222",
        marginRight: "8px"
    },
    select: {
        display: "flex",
    },
    input: {
        '& div': {
            backgroundColor: "transparent",
            fontFamily: "Mulish",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#FEFFFF"
        }
    },
});

export default function ColorSelect(props) {
    const classes = useStyles();

    return (
        <Autocomplete
            id="color"
            fullWidth
            options={colors}
            classes={{
                root: classes.input,
                option: classes.option,
            }}
            className={'myClass1'}


            onChange={props.onChange}
            inputValue={props.inputValue}
            onInputChange={props.onInputChange}
            autoHighlight
            getOptionLabel={(option) => option.name}
            renderOption={(option) => (
                <React.Fragment>
                    <Box className={classes.select}>
                        <Box className={classes.colorBox} style={{backgroundColor: option.code}}></Box>
                        <Box>{option.name}</Box>
                    </Box>
                </React.Fragment>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    //label={props.label}
                    helperText={props.helperText}
                    error={props.error}
                    inputProps={{
                        ...params.inputProps,
                        //autoComplete: true, // disable autocomplete and autofill
                    }}
                    margin="dense"
                    variant="outlined"
                    className={classes.input}

                />
            )}
        />
    );
}
